<app-modal #modal>
  <div class="modal-content">
    <div class="modal-header">
      <div>
        <h5 class="modal-title fw-bold" *ngIf="subscription">
          Renewal rule — {{ personName(subscription) }} &middot;
          {{ productLabel(subscription) }}
        </h5>
        <span class="text-muted small">Monthly renewals anchored on the activation day</span>
      </div>
      <button
        type="button"
        class="btn-close"
        (click)="modal.hide()"
        aria-label="Close"
      ></button>
    </div>
    <div class="modal-body" *ngIf="subscription">
      <p class="text-muted small">
        Renewal rules drive billing records only — stopping or expiring a
        subscription does not change the member's real school status or
        product access.
      </p>
      <div
        *ngIf="isBooksSubscription(subscription)"
        class="alert alert-warning py-2 small"
      >
        Not fully working yet: books access is not integrated with
        subscriptions, so when this subscription expires the billing stops
        while the teacher keeps the books product. Only re-granting the
        product on the products page starts a new paid period.
      </div>
      <div class="form-check form-switch mb-3">
        <input
          class="form-check-input"
          type="checkbox"
          id="ruleAutoRenew"
          [(ngModel)]="autoRenew"
        />
        <label class="form-check-label" for="ruleAutoRenew">
          Renew automatically every month
        </label>
      </div>
      <div
        *ngIf="subscription.status === SubscriptionStatus.Inactive && autoRenew"
        class="alert alert-info py-2 small"
      >
        This subscription has expired; with renewals enabled the system reopens
        it as a billable renewal while the member is active.
      </div>

      <fieldset [disabled]="!autoRenew">
        <div class="form-check mb-2">
          <input
            class="form-check-input"
            type="radio"
            name="ruleChoice"
            id="ruleNone"
            value="none"
            [(ngModel)]="rule"
          />
          <label class="form-check-label" for="ruleNone">
            Renew until manually stopped
          </label>
        </div>
        <div class="form-check mb-2">
          <input
            class="form-check-input"
            type="radio"
            name="ruleChoice"
            id="ruleMonths"
            value="months"
            [(ngModel)]="rule"
          />
          <label class="form-check-label" for="ruleMonths">
            Renew for a total of
            <input
              class="form-control form-control-sm d-inline-block mx-1"
              style="width: 5rem"
              type="number"
              min="1"
              step="1"
              [(ngModel)]="months"
              name="ruleMonthsValue"
              [disabled]="rule !== 'months'"
            />
            months from the activation day (the first month included)
          </label>
          <div
            *ngIf="rule === 'months' && months != null && !ruleEditValid"
            class="text-danger small"
          >
            Enter a whole number of months (at least 1).
          </div>
        </div>
        <div class="form-check mb-2">
          <input
            class="form-check-input"
            type="radio"
            name="ruleChoice"
            id="ruleUntil"
            value="until"
            [(ngModel)]="rule"
          />
          <label class="form-check-label" for="ruleUntil">
            Renew until
            <input
              class="form-control form-control-sm d-inline-block mx-1"
              style="width: 10rem"
              type="date"
              [(ngModel)]="untilDate"
              name="ruleUntilValue"
              [disabled]="rule !== 'until'"
            />
            (a renewal falling on that day still happens)
          </label>
        </div>
        <div *ngIf="untilDateInPast" class="text-warning small mb-2">
          The date is in the past — the subscription will not renew again and
          will expire at the end of the paid month.
        </div>
      </fieldset>

      <div class="form-floating mt-3">
        <input
          class="form-control"
          type="text"
          id="ruleNotes"
          [(ngModel)]="notes"
          name="ruleNotes"
          placeholder="Notes"
        />
        <label for="ruleNotes">Notes (optional, recorded in the audit)</label>
      </div>

      <div *ngIf="error" class="alert alert-danger py-2 small mt-3 mb-0">
        {{ error }}
      </div>
    </div>
    <div class="modal-footer">
      <button
        type="button"
        class="btn btn-outline-secondary-2 rounded-pill px-4 py-2"
        (click)="modal.hide()"
      >
        Cancel
      </button>
      <button
        type="button"
        class="btn btn-primary rounded-pill px-4 py-2"
        [disabled]="saving || !ruleEditValid"
        (click)="save()"
      >
        Save rule
        <span
          *ngIf="saving"
          class="spinner-grow spinner-grow-sm"
          role="status"
          aria-hidden="true"
        ></span>
      </button>
    </div>
  </div>
</app-modal>
